export const brandColors = {
  brandOne: '#02315B',
  brandTwo: '#228300',
  brandThree: '#078463',
} as const;
